import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-24 h-24 rounded-full border border-borderColor relative mb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  class: "w-[16px] h-[16px]",
  version: "1.1",
  viewBox: "0 0 512 512",
  "xml:space": "preserve"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#DC2626",
    d: "M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5  c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9  c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "w-full h-full rounded-full" }
const _hoisted_5 = { class: "w-full h-full cursor-pointer overflow-x-hidden overflow-y-clip" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  for: "form-img",
  class: "w-full h-full rounded-full flex items-center bg-primary300 justify-center z-10"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13 5H9.32843C8.79799 5 8.28929 5.21071 7.91421 5.58579L7.08579 6.41421C6.71071 6.78929 6.20201 7 5.67157 7H4C2.89543 7 2 7.89543 2 9L2 19C2 20.1046 2.89543 21 4 21H18C19.1046 21 20 20.1046 20 19V12M17 5H23M20 8V2M11 18C13.2091 18 15 16.2091 15 14C15 11.7909 13.2091 10 11 10C8.79086 10 7 11.7909 7 14C7 16.2091 8.79086 18 11 18Z",
    stroke: "#fff",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "w-24 h-24 cursor-pointer rounded-full"
}
const _hoisted_11 = {
  key: 0,
  class: "w-full h-full flex items-center justify-center bg-gradiant-primery rounded-full"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "loader-avatar" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["src"]

import { ref } from 'vue'


interface Props {
    changeAvatar: boolean
    loadImg: boolean
    srcAvatar: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AvatarUpload',
  props: {
    changeAvatar: { type: Boolean },
    loadImg: { type: Boolean },
    srcAvatar: null
  },
  emits: ["removeAvatar", "previewFile"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'removeAvatar'): void
    (event: 'previewFile', payload: any): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    changeAvatar: boolean
    loadImg: boolean
    srcAvatar: string
};




const inputAvatar = ref<any>(null)

const previewFile = (e: any) => {
    emit('previewFile', e.target.files[0])

};

const handelRemoveAvatar = () => {
    inputAvatar.value.value = ''
    emit('removeAvatar')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.changeAvatar)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          onClick: handelRemoveAvatar,
          class: "z-10 absolute top-1 -right-1 w-7 h-7 bg-white border border-titlePage rounded-full cursor-pointer flex items-center justify-center"
        }, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("input", {
          ref_key: "inputAvatar",
          ref: inputAvatar,
          type: "file",
          name: "from-img",
          id: "from-img",
          disabled: __props.loadImg,
          class: "opacity-0 absolute w-full h-full cursor-pointer",
          accept: "image/*",
          onChange: previewFile
        }, null, 40, _hoisted_6),
        (__props.changeAvatar)
          ? (_openBlock(), _createElementBlock("label", _hoisted_7, _hoisted_9))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (__props.loadImg)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    ref: "imgAddContact",
                    id: "img-add-contact",
                    class: "w-24 h-24 rounded-full z-0 cursor-pointer",
                    src: __props.srcAvatar,
                    alt: "avatar"
                  }, null, 8, _hoisted_14))
            ]))
      ])
    ])
  ]))
}
}

})